import sortByCategory from "@local/extensions/utilities/sort-by-category.js";

export default function orderProductItems(
  grouped,
  types,
  productGroup,
  categories,
  supplier,
) {
  const o = [];
  let index = 0;

  let t;

  if (productGroup) {
    if (categories) {
      t = sortByCategory(types, categories);
    } else {
      t = types;
    }

    t = t.filter((t) => grouped[t.id]?.length);
  } else {
    t = types;
  }

  t.forEach((type) => {
    const items = grouped[type.id] || [];

    o.push({
      type,
      items,
      index,
    });

    index += items.length;
  });

  if (grouped.untyped.length) {
    o.push({
      type: null,
      items: grouped.untyped,
      index,
    });
  }

  return o;
}
